import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { ConfirmDialog } from '@futures-platform/ui'
import { toggleConfirmationDialog } from '../actions/confirmDialog'

export default connect(
    state => state.confirmDialog,
    dispatch => ({
        ...bindActionCreators({
            toggleConfirmationDialog
        }, dispatch)
    })
)(ConfirmDialog)
